import { UNIDADES } from "@caint/data";
import {
  RelatorioExecutivo,
  type RelatorioExecutivoProps,
} from "../../components/relatorio/RelatorioExecutivo.tsx";
import { PageHeader } from "../ui/kit.tsx";

export type RelatorioDesktopProps = RelatorioExecutivoProps;

export function RelatorioDesktop(props: RelatorioDesktopProps) {
  const ativa = UNIDADES.find((u) => u.id === props.avaliacaoAtual?.unidadeId);
  return (
    <div className="dk-page" style={{ maxWidth: 1320 }}>
      <div
        className="no-print"
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        <PageHeader titulo="Relatório Executivo" sub={ativa?.nome ?? "Unidade"} />
        <button type="button" className="m-btn" onClick={() => window.print()}>
          🖨 Imprimir / PDF
        </button>
      </div>
      <RelatorioExecutivo {...props} />
    </div>
  );
}
